import { createTheme } from "@mui/material/styles";
import { createOutpaveTheme } from "@outpave/ds";
import type { BrandIdentity, ThemePresetName } from "@outpave/ds";
import { dsIcons } from "./dsIcons";

/**
 * THE breakpoints. Every width decision in the app resolves here, so tuning a
 * tier is one edit rather than a search.
 *
 * They are MUI's own defaults, stated explicitly rather than inherited: the
 * package theme sets none, and leaving them implicit is how the app ended up
 * with five disagreeing sources (a 900px hook, a 1039.95px query, a 768-1023
 * range, dead 375/834/1440 CSS variables, and Tailwind's screens). Writing
 * them down is what makes them ours to change.
 *
 * This module is now the only source: Tailwind and its mirrored `screens` were
 * removed in OUT-1174.
 *
 * Never hand-write a media query against these. `theme.breakpoints.down("md")`
 * emits the boundary MUI expects, including the fractional edge that stops
 * `up` and `down` overlapping at the same pixel.
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

/** The only createTheme call that survives the migration (DS_MIGRATION.md). */
export const buildOutpaveTheme = (
  identity?: BrandIdentity,
  preset: ThemePresetName = "house",
) =>
  createTheme(
    createOutpaveTheme({
      ...(identity ? { identity } : {}),
      icons: dsIcons,
      preset,
    }),
    { breakpoints: { values: { ...BREAKPOINTS } } },
  );

/** Base-brand instance for boot, tests, and identity-less contexts. */
export const outpaveTheme = buildOutpaveTheme();
